// extracted by mini-css-extract-plugin
export default {"modal-automate-details":"ModalAutomate_modal-automate-details__j9MaC","modal-automate-runs":"ModalAutomate_modal-automate-runs__gsHFT"};